import type { ValueOf } from 'type-fest';

export type DeactivationReason = ValueOf<typeof DEACTIVATION_REASONS>;
export type Step = ValueOf<typeof STEPS>;

export const DEACTIVATION_REASONS = {
  FOUND_RENTER_ELSEWHERE: 'FOUND_RENTER_ELSEWHERE',
  TENANT_RENEWED: 'TENANT_RENEWED',
  STILL_LOOKING_PAUSING_ON_ZILLOW: 'STILL_LOOKING_PAUSING_ON_ZILLOW',
} as const;

export const ANSWER_CARD_CONFIG = [
  {
    reason: DEACTIVATION_REASONS.FOUND_RENTER_ELSEWHERE,
    title: 'I found a new tenant',
  },
  {
    reason: DEACTIVATION_REASONS.TENANT_RENEWED,
    title: 'My current tenant renewed',
  },
  {
    reason: DEACTIVATION_REASONS.STILL_LOOKING_PAUSING_ON_ZILLOW,
    title: 'I am still looking for a tenant but am pausing this Zillow listing',
  },
] as const;

export const STEPS = {
  ADD_TENANT_SELECT: 'addTenantSelect',
  DEACTIVATION_REASON: 'deactivationReason',
  NOTIFY_LEADS: 'notifyLeads',
  UPSELL: 'upsell',
} as const;
